import { routerMiddleware, routerReducer } from 'react-router-redux'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'

import actions from './actions'
import config from '../config'
import enhancers from './enhancers'
import middlewares from './middlewares'
import reducers from './reducers'
import { send } from '../helpers/requests'

const configureStore = (state, history) => {
    // The reducers.
    const reducer = combineReducers({ ...reducers, routing: routerReducer })

    // The middleware and the enhancers.
    const middleware = applyMiddleware(...middlewares, thunk.withExtraArgument(send), routerMiddleware(history))
    const hasReduxDevtools = typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    const composeEnhancers = (config.env === 'development' && hasReduxDevtools)
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ actions })
        : compose
    const enhancer = composeEnhancers(middleware, ...enhancers)

    // Create the store.
    const store = createStore(reducer, state, enhancer)

    return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/index.js